module.exports = __webpack_public_path__ + "img/warehouse-management.2cac7a08.svg";